import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-page_view-view';

/**
 * Tracks page views for key pages that we manually pick.

Parameters: * is required
Brand: brand token for brand page
Product: product token for product page
Query: search query or discover term
Page Type*: product area for page
Page path*: relative url path
Page Name*: name of page for differentiation (e.g. page-category-product vs page-category-brand)
c1: c1 for category page
c2: c2 for category page
c3: c3 for category page
 */
export function trackRetailersPageViewView(
  Brand: string,
  Product2: string,
  Query3: string,
  Page_Type4: string,
  Page_Path5: string = '',
  Page_Name6: string = '',
  c17: string = '',
  c28: string = '',
  c39: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      Brand,
      Product2,
      Query3,
      Page_Type4,
      Page_Path5,
      Page_Name6,
      c17,
      c28,
      c39,
    },
  });
}
